import { Grid } from "@mui/material";
import GeneratedTickets from "./generated-tickets";
import GitLabTicketConfigurationForm from "./ticket-configuration";
import { useGetTicketTypesQuery } from "@/services/ticket-service/ticketGeneratorApis";
import { useTicketContext } from "@/views/pages/tickets/TicketContext";
import { useCallback } from "react";
import { GenerateTicketService } from "@/services/ticket-service/gernerate-ticket";
import { toast } from "react-toastify";
interface FormValues {
  gitlabRepository: string;
  ticketType: string;
  linkedUserStory: number;
  description: string;
}
/**
 * This component will handle the ticket generation logic, it will call the generate service
 * and set the context and history in the ticket context initally
 */
const TicketSubmitHandler = () => {
  const { data: ticketTypes } = useGetTicketTypesQuery();
  const { setContent, setHistory, setIsLoading } = useTicketContext();

  const ticketGenerationHandler = useCallback(
    async (data: FormValues) => {
      /**
       * Generate a new ticket this function will called when we click the generate ticket button from the ticket configuration
       */

      const payload = {
        ticketType: ticketTypes?.find((item) => item.id === data?.ticketType)?.systemName as string,
        context: data?.description as string,
        history: []
      };
      setIsLoading(true);
      try {
        const response = await GenerateTicketService(payload);

        if (!response) {
          throw new Error("Error generating ticket");
        }

        setContent(response);
        setHistory((prev) => [
          ...prev,
          { context: payload.context, title: response.title, description: response.description }
        ]);
        setIsLoading(false);
      } catch (error: any) {
        console.log(error);
        toast.error(error?.message || "Error generating ticket");
      } finally {
        setIsLoading(false);
      }
    },
    [ticketTypes]
  );

  return (
    <Grid container spacing={2} wrap="wrap">
      <Grid item xs={12} sm={12} md={12} lg={4}>
        <GitLabTicketConfigurationForm submitTicketGenerator={ticketGenerationHandler} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={8}>
        <GeneratedTickets />
      </Grid>
    </Grid>
  );
};

export default TicketSubmitHandler;
